'use client';

import { useTheme } from 'next-themes';
import { Logo } from '@/components/layout/logo';
import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { theme, setTheme } = useTheme();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-muted/40 px-4 py-12">
      {/* Botao de tema no canto superior direito */}
      <div className="absolute right-4 top-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          aria-label="Alternar tema"
        >
          <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
        </Button>
      </div>

      {/* Logo acima do card */}
      <div className="mb-6 flex flex-col items-center gap-2">
        <a href="https://nossoerp.com.br/" target="_blank" rel="noopener noreferrer" className="flex justify-center">
          <Logo
            width={168}
            height={48}
            priority
          />
        </a>
        <h1 className="text-xl font-semibold tracking-tight">
          Portal do Contador
        </h1>
      </div>

      {/* Card container */}
      <div className="w-full max-w-md">{children}</div>
    </div>
  );
}
